// How a route is named on screen.
//
// A Kursbuchstrecke is a German thing. Switzerland numbers its own timetable lines in the
// same three-digit range, and 33 numbers exist in both countries — 611, 701, 702, 730 and
// 761 among them. So a foreign route is keyed with its country ("CH 702") and must not be
// announced as a KBS: "KBS CH 702" would be wrong twice over.
//
// The country arrives as its own field from the API. Parsing the key is the fallback, for
// responses issued before migration 0029 and for the mock.

const PREFIXED = /^([A-Z]{2})\s/;

export const routeCountry = (number, country) =>
  country || PREFIXED.exec(number || '')?.[1] || 'DE';

/** "KBS 702" at home, "CH 702" abroad — the key already carries the prefix. */
export const routeLabel = (number, country) =>
  (routeCountry(number, country) === 'DE' ? `KBS ${number}` : String(number ?? ''));

/** Just the number, without the country — for tight spots like the map chip. */
export const routeNumber = (number) => String(number ?? '').replace(PREFIXED, '');
